// extracted by mini-css-extract-plugin
export default {"icon":"icon-wrapper_icon__PPr-b"};